import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useForgotPasswordMutation } from 'services/api/ums';
import { isValidEmail } from '../helpers';
import { UMS_ACCOUNT_NAME } from '../constants';
import { StyledModal } from './style';

function ForgotPasswordModal({ show, onHide }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setEmail('');
    setError('');
  }, [show]);

  const [forgotPassword, forgotPasswordState] = useForgotPasswordMutation();

  useEffect(() => {
    if (forgotPasswordState.isError) {
      setError(get(forgotPasswordState, 'error.data.message'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPasswordState.isError]);

  useEffect(() => {
    if (forgotPasswordState.isSuccess) {
      toast.success(get(forgotPasswordState, 'data.message'));
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPasswordState.isSuccess]);

  return (
    <StyledModal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Forgot Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group
          className={
            !email
              ? 'form-group'
              : isValidEmail(email)
                ? 'form-group success'
                : 'form-group error'
          }
        >
          <Form.Label>Email Address *</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Form.Group>
        {error && <div className="error-message">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!isValidEmail(email) || forgotPasswordState.isLoading}
          onClick={() =>
            forgotPassword({ email, accountName: UMS_ACCOUNT_NAME })
          }
        >
          Submit
        </Button>
        <Button onClick={onHide} variant="secondary">
          Cancel
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}

export default ForgotPasswordModal;
